import { LocationType } from '@wix/ambassador-bookings-availability-v1-slot-availability/types';
import { bulkSlotsSize, DataStatus, ErrorTypes } from '../../appointment-state';
export const initialErrorState = loadInitialAppointmentDataResponse => {
  const {
    service
  } = loadInitialAppointmentDataResponse || {};
  const serviceId = service == null ? void 0 : service.id;
  if (!serviceId) {
    return {
      type: ErrorTypes.GENERAL,
      message: 'Service ID is missing'
    };
  }
  return null;
};
export const initialDefaultState = _ref => {
  let {
    appointmentFieldProps,
    isEditor,
    isComposer
  } = _ref;
  const {
    initialData
  } = appointmentFieldProps;
  const dummyData = initialDummyData();
  if (isEditor || isComposer) {
    return {
      ...dummyData,
      timezone: getUserTimezone(),
      dataStatus: DataStatus.DONE
    };
  } else {
    const initialError = initialErrorState(initialData);
    if (initialError) {
      return {
        dataStatus: DataStatus.ERROR,
        error: initialError
      };
    }
  }
  return {
    ...dummyData,
    dataStatus: DataStatus.LOADING
  };
};
export const getStartAndEndDate = (durationInMonths, timeZone) => {
  const startDate = new Date();
  const endDate = new Date(startDate);
  endDate.setMonth(endDate.getMonth() + durationInMonths);

  // Adjust both dates to the specified time zone
  const startDateInTimeZone = new Date(startDate.toLocaleString('en-US', {
    timeZone
  }));
  const endDateInTimeZone = new Date(endDate.toLocaleString('en-US', {
    timeZone
  }));
  return {
    startDate: startDateInTimeZone,
    endDate: endDateInTimeZone
  };
};
export const getUserTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
export const calculateSelectedDate = availabilityDates => {
  var _availabilityDates$, _availabilityDates$0$;
  if (!(availabilityDates != null && (_availabilityDates$ = availabilityDates[0]) != null && (_availabilityDates$ = _availabilityDates$.slot) != null && _availabilityDates$.startDate)) {
    return undefined;
  }
  return new Date((_availabilityDates$0$ = availabilityDates[0].slot) == null ? void 0 : _availabilityDates$0$.startDate);
};
export const calculateSelectedSlot = (availabilitySlots, timezone) => {
  var _availabilitySlots$, _availabilitySlots$2;
  if (!(availabilitySlots != null && availabilitySlots.length)) {
    return undefined;
  }
  return {
    startDate: ((_availabilitySlots$ = availabilitySlots[0]) == null || (_availabilitySlots$ = _availabilitySlots$.slot) == null ? void 0 : _availabilitySlots$.startDate) || '',
    endDate: ((_availabilitySlots$2 = availabilitySlots[0]) == null || (_availabilitySlots$2 = _availabilitySlots$2.slot) == null ? void 0 : _availabilitySlots$2.endDate) || '',
    timeZone: timezone || ''
  };
};
export const initialDummyData = function (_temp) {
  var _availabilityDates$2;
  let {
    duration = 60,
    timezone = 'UTC'
  } = _temp === void 0 ? {} : _temp;
  const serviceId = '267d1c11-8019-4e3d-b9c6-cd2b859c69e2';
  const now = new Date();
  const availabilityDates = [];
  const availabilitySlots = [];
  const dateStr = now.toISOString().split('T')[0];
  const startHour = 10;
  const endHour = 18;
  let start = new Date(`${dateStr}T${startHour}:00:00`);
  let end = new Date(start);
  end.setMinutes(end.getMinutes() + duration);
  let addedDateSlot = false;
  while (end.getHours() < endHour || end.getHours() === endHour && end.getMinutes() === 0) {
    const slot = {
      slot: {
        serviceId,
        startDate: start.toISOString(),
        endDate: end.toISOString(),
        location: {
          locationType: LocationType.CUSTOM
        }
      },
      bookable: true,
      totalSpots: 1,
      openSpots: 1,
      bookingPolicyViolations: {
        tooEarlyToBook: false,
        tooLateToBook: false,
        bookOnlineDisabled: false
      },
      nestedSlots: []
    };
    availabilitySlots.push(slot);
    if (!addedDateSlot) {
      availabilityDates.push(slot);
      addedDateSlot = true;
    }
    start = new Date(end);
    end = new Date(start);
    end.setMinutes(end.getMinutes() + duration);
  }
  return {
    availabilitySlots,
    availabilityDates,
    timezone,
    currentSlotBulkSize: bulkSlotsSize,
    selectedDate: availabilityDates.length > 0 && (_availabilityDates$2 = availabilityDates[0]) != null && (_availabilityDates$2 = _availabilityDates$2.slot) != null && _availabilityDates$2.startDate ? new Date(availabilityDates[0].slot.startDate) : undefined
  };
};
//# sourceMappingURL=utils.js.map